import { Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ExtensionPoint, EXTENSION_POINTS } from "src/components/PuckExtensions";
import { ReferenceBox } from "src/components/ReferenceBox";
import { useProductMetadataContext } from "src/context/Product/Metadata/useProductMetadata";
import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { useIsProductUxV2 } from "src/hooks/useIsProductUxV2";
import { OneCompanyScores } from "./Scores/OneCompanyScores";

export const ProductScores = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    const { product, productReference } = useProductMetadataContext();
    const { currentCampaign } = useFoodpilotContext();
    const isProductUxV2 = useIsProductUxV2();

    const scoreCards = <OneCompanyScores />;

    return (
        <Stack gap={isProductUxV2 ? 0 : theme.spacing(2)} paddingTop={isProductUxV2 ? 0 : theme.spacing(2)}>
            <ExtensionPoint extensionPoint={EXTENSION_POINTS.PRODUCT_DETAIL_SCORE_HEADER} />
            {isProductUxV2 ?
                <Stack
                    alignItems="center"
                    direction="row"
                    flexWrap="wrap"
                    gap={theme.spacing(1)}
                    sx={{
                        minWidth: 0,
                        paddingBottom: theme.spacing(3),
                        paddingTop: theme.spacing(3),
                    }}
                >
                    <Typography variant="h2">
                        {t("product.v2.scores.indicators.title", "Indicators of {{productName}}", {
                            productName: product.title,
                        })}
                    </Typography>
                    <Typography
                        sx={{
                            color: theme.custom.grey[2500],
                            paddingLeft: theme.spacing(1),
                        }}
                        variant="big-regular"
                    >
                        {currentCampaign?.label}
                    </Typography>
                </Stack>
            :   <Typography variant="h2">
                    {t("product.scores.indicators.title", "Indicators from your product in {{year}}", {
                        year: currentCampaign?.label,
                    })}
                </Typography>
            }
            {isProductUxV2 ?
                <Stack gap={theme.spacing(2)} sx={{ minWidth: 0 }}>
                    <ReferenceBox name={productReference?.name} />
                    {scoreCards}
                </Stack>
            :   <>
                    <ReferenceBox name={productReference?.name} />
                    {scoreCards}
                </>
            }

            <ExtensionPoint extensionPoint={EXTENSION_POINTS.PRODUCT_DETAIL_SCORE_FOOTER} />
        </Stack>
    );
};
